<div class="modal-header">
  <h3 class="modal-title">
    {{ title }}
    <i (click)="close()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
    <i class="fa pull-right"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
  </h3>
</div>

<div class="modal-body" [hidden]="minimise">
  <h4 style="overflow: hidden">
    <div style="float:left"><img src="assets/img/chrome.png" width="50px"></div>
    <div style="margin:15px 0px 0px 60px">For best experience use <b>Google Chrome</b> as your browser.</div>
  </h4>

  <div style="margin-top:35px">
    <b>Please copy this url and open it in Google Chrome:</b>
    <div class="panel panel-default" style="margin-top:12px; background-color:#5d5f5f; color:#ffdddd">
      <div class="panel-body">
        {{ url }}
      </div>
    </div>
  </div>
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="cancel-button" type="button" (click)="close()">Close</button>
</div>
